export const RESOLVE_NOTE_DEFAULT_VALUES = {
  resolutionNotes: '',
};
